/**
 * Thread search lever (PR-5, 2026-09-09): `REACT_APP_THREAD_SEARCH=off` hides
 * the search box on the rail and the mobile sheet (the instant tier and the
 * deep tier alike). Default on.
 */
export function threadSearchEnabled(env: Record<string, string | undefined> = process.env): boolean {
  return String(env.REACT_APP_THREAD_SEARCH ?? '').trim().toLowerCase() !== 'off';
}
